import React, { useEffect, useState } from "react"
import { Link } from "react-router"
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from "react-redux"
import { Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import Rightbar from 'pages/main/wms/documentsIn/Rightbar'
import DeleteModal from 'pages/parts/DeleteModal'
import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import useFilterSearchPagination from 'pages/parts/useFilterSearchPagination'
import DocumentStatusHistory from 'pages/parts/DocumentStatusHistory'
import PeriodPicker from 'pages/parts/PeriodPicker'

import { httpOk, GET, DELETE } from 'helpers/api'
import { formatDate, formatMoney, returnSign, findKeyFromArrayByValue } from "helpers/helpers"
import { SET_FILTER_DATA } from "store/filterData/actions"

function Index() {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const date = new Date()

	const reduxFilterData = useSelector(state => state.filterData)
	const reduxAccount = useSelector(state => state.account)

	const [data, setData] = useState({})
	const [statusHistoryId, setStatusHistoryId] = useState(null)
	const [documentStatuses, setDocumentStatuses] = useState([])
	const [poses, setPoses] = useState([])
	const [suppliers, setSuppliers] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [showRightBar, setShowRightBar] = useState({ 'document': false })
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const initialFilterData = {
		start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
		end_date: formatDate(new Date(), 'yyyy-MM-dd'),
		to_pos_id: reduxAccount.pos_id,
		document_status: null,
		search: '',
	}
	const initialPagination = { url: '', response: null }
	const {
		filterData,
		appliedFilterData,
		filterDataExist,
		setFilterDataExist,
		pagination,
		setPagination,
		patchFilterData,
		applySearch,
		applyFilters,
		paginate,
		resetFilters,
	} = useFilterSearchPagination({ initialFilterData, initialPagination })
	const [modalDelete, setModalDelete] = useState(false)
	const [deleteModalParams, setDeleteModalParams] = useState({ id: 0, index: 0 })

	async function searchWithFilter(customFilterData = filterData, settings = { reduxData: false }) {
		var filterUrl = "/wms-transfer-branch-documents"
		var urlParams = ""
		checkFilter()

		var filterDataCopy = {}
		if (settings?.reduxData) {
			filterDataCopy = reduxFilterData
			urlParams = ""
		} else {
			filterDataCopy = { ...customFilterData }
			urlParams = ""
		}

		if (filterDataCopy.to_pos_id)
			urlParams += returnSign(urlParams) + 'to_pos_id=' + filterDataCopy.to_pos_id
		if (filterDataCopy.supplier_id)
			urlParams += returnSign(urlParams) + 'supplier_id=' + filterDataCopy.supplier_id
		if (filterDataCopy.document_status)
			urlParams += returnSign(urlParams) + 'document_status=' + filterDataCopy.document_status
		if (filterDataCopy.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterDataCopy.start_date
		if (filterDataCopy.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterDataCopy.end_date
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page
		if (`/wms-transfer-branch-documents${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams
		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
			filterDataCopy.url = '/wms-transfer-branch-documents'
			dispatch(SET_FILTER_DATA(filterDataCopy))
		}

		setDropdownIsOpen(false)
	}

	async function deleteItem() {
		var response = await DELETE(`/wms-transfer-branch/${deleteModalParams.id}`, {}, { loader: true })
		if (httpOk(response)) {
			setModalDelete(false)
			searchWithFilter()
		}
	}

	async function toggleRightbar(boolean = false, item) {
		if (boolean) {
			const response = await GET(`/wms-transfer-branch-documents/${item.id}`, {}, { loader: true })
			if (httpOk(response)) {
				setSelectedItem(response.data)
				setShowRightBar({ ...showRightBar, 'document': true })
			}
		} else {
			setSelectedItem({})
			setShowRightBar({ ...showRightBar, 'document': false })
		}
	}

	function returnClassStatus(status) {
		if (status === 1) {
			return "bg-success"
		}
		if (status === -1) {
			return "bg-danger"
		}
		if (status === -2) {
			return "bg-secondary"
		}
	}

	function resetFilter() {
		resetFilters({
			start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
			end_date: formatDate(new Date(), 'yyyy-MM-dd'),
			pos_id: filterData.pos_id ?? '',
			search: '',
		}, searchWithFilter)
		dispatch(SET_FILTER_DATA({}))
	}

	function checkFilter() {
		if (filterData.search === '') {
			// managed by hook when filters are reset
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	function handlePaginate(page) {
		const nextFilterData = { ...filterData, page }
		paginate(page)
		searchWithFilter(nextFilterData)
	}

	async function getPoses() {
		const response = await GET('/helper/poses', {}, { loader: true })
		if (httpOk(response)) setPoses(response.data)
	}

	async function getSuppliers() {
		const response = await GET('/helper/suppliers', {}, { loader: true })
		if (httpOk(response)) setSuppliers(response.data)
	}

	async function getDocumentStatuses() {
		const response = await GET('/helper/document-statuses?entity=wms_transfer_branch')
		if (httpOk(response)) setDocumentStatuses(response.data)
	}

	useEffect(() => {
		getDocumentStatuses()
		getPoses()
		getSuppliers()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('receipt_from_branch')} [{data.total}]
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									value={filterData.search}
									onSearchChange={(search) => applySearch(search, searchWithFilter)}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('pos')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.to_pos_id) || ''}
													onChange={(option) => patchFilterData({ 'to_pos_id': option.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('suppliers')}</label>
												<Select
													options={suppliers}
													value={suppliers.find(option => option.id === filterData.supplier_id) || ''}
													onChange={(option) => patchFilterData({ 'supplier_id': option.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('status')}</label>
												<Select
													isClearable
													options={documentStatuses}
													value={documentStatuses.find(option => option.value === filterData.document_status) || ''}
													onChange={(option) => patchFilterData({ 'document_status': option ? option.value : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => t(option.value)}
													getOptionValue={(option) => option.value}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-12">
												<label>{t('period')}</label>
												<PeriodPicker
													startDate={filterData.start_date}
													endDate={filterData.end_date}
													onChange={(period) => patchFilterData(period)}
													withTime={false}
													minDate={new Date(new Date().getFullYear() - 1, 0, 1)}
													maxDate={new Date(new Date().getFullYear(), 11, 31)}
												/>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary"
														onClick={() => setDropdownIsOpen(false)}>
														{t('cancel')}
													</button>
													<button className="btn btn-primary"
														onClick={() => applyFilters(searchWithFilter)}>
														{t('apply')}
													</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(appliedFilterData.start_date || appliedFilterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{appliedFilterData.start_date &&
											<span>{formatDate(appliedFilterData.start_date)}</span>
										}
										{(appliedFilterData.start_date && appliedFilterData.end_date) &&
											<span>|</span>
										}
										{appliedFilterData.end_date &&
											<span>{formatDate(appliedFilterData.end_date)}</span>
										}
									</span>
								}
								{appliedFilterData.pos_id &&
									<span className="me-2">
										<b>{t('pos')}: </b>
										{findKeyFromArrayByValue(poses, 'id', appliedFilterData.pos_id, 'name')}
									</span>
								}
								{appliedFilterData.document_status &&
									<span className="me-2">
										<b>{t('status')}: </b>
										{t(appliedFilterData.document_status)}
									</span>
								}
								{appliedFilterData.supplier_id &&
									<span className="me-2">
										<b>{t('supplier')}: </b>
										{findKeyFromArrayByValue(suppliers, 'id', appliedFilterData.supplier_id, 'name')}
									</span>
								}
								{appliedFilterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{appliedFilterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '20%' }}>{t('pos')}</th>
									<th style={{ 'width': '10%' }}>{t('supplier')}</th>
									<th style={{ 'width': '40%' }}>{t('note')}</th>
									<th style={{ 'width': '10%' }} className="text-center">{t('status')}</th>
									<th style={{ 'width': '10%' }} className="text-center">{t('date')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('amount')}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{item.row_number}</td>
										<td className="td-ellipsis"
											onClick={() => toggleRightbar(true, item)}>
											<span className="text-primary cursor">{item.to_pos_name}</span>
										</td>
										<td>{item.pos_name}</td>
										<td className="td-ellipsis" title={item.note}>{item.note}</td>
										<td className={`text-center text-white ${returnClassStatus(item.status)}`}>
											{item.status === 1 &&
												<span>{t('success')}</span>
											}
											{item.status === -1 &&
												<span>{t('deleted')}</span>
											}
											{item.status === -2 &&
												<span>{t('expected')}</span>
											}
										</td>
										<td className="text-center text-nowrap">
											{formatDate(item.created_at, 'dd.MM.yy HH:mm')}
										</td>
										<td className="text-end text-nowrap">{formatMoney(item.total_price)}</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<Link to={`/wms-transfer-branch/documents/preview/${item.id}`} className="table-dropdown-item">
															<i className="uil-eye"></i>
															{t('preview')}
														</Link>
														<div className="table-dropdown-item"
															onClick={() => setStatusHistoryId(item.id)}>
															<i className="uil-history"></i>
															{t('document_status_history')}
														</div>
														{/* Удаление — последним пунктом: промах мимо соседнего пункта дороже всего */}
														{item.status === -2 &&
															<div className="table-dropdown-item text-danger"
																onClick={() => {
																	setDeleteModalParams({ id: item.id, index: index });
																	setModalDelete(true)
																}}>
																<i className="uil-times"></i>
																{t('delete')}
															</div>
														}
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={handlePaginate}>
						</FilterPagination>
					}
				</div>
			</div>

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>

			{showRightBar.document &&
				<Rightbar
					showRightBar={showRightBar.document}
					setShowRightBar={setShowRightBar}
					data={selectedItem}>
				</Rightbar>
			}

			<DocumentStatusHistory
				entity="wms_transfer_branch"
				documentId={statusHistoryId}
				setDocumentId={setStatusHistoryId}>
			</DocumentStatusHistory>
		</>
	)
}

export default Index